<script>
import Chart from "@/components/widgets/chart";
import { api } from "@/state/services";

export default {
  components: { Chart },
  data() {
    return {
      empty: true,

      resume: {
        paid: 0,
        prediction: 0,
        total: 0
      },

      chartdata: {},
      options: {}
    }
  },
  methods: {
    getChart() {
      api
        .get('chart/bonus')
        .then(response => {
          if (response.data.status == 'success') {
            this.resume = response.data.chart.resume;

            this.chartdata = {
              labels: response.data.chart.labels,
              datasets: [
                {
                  label: 'Total',
                  backgroundColor: ["#16A085", "#9B59B6", "#8E44AD", "#27AE60", "#2ECC71", "#3498DB", "#2980B9", "#1ABC9C"],
                  data: response.data.chart.data,
                }
              ]
            }

            this.options = {
              defaultFontColor: '#6DA544',
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                xAxes: [
                  {
                    ticks: {
                      maxTicksLimit: 10,
                    },
                  },
                ],
                yAxes: [
                  {
                    ticks: {
                      max: response.data.chart.max,
                      min: 0,
                      stepSize: response.data.chart.step,
                    },
                  },
                ],
              },
            }

            this.empty = false
          } else {
            this.empty = true
          }
        })
    }
  },
  mounted() {
    this.getChart();
  },
}
</script>

<template>
  <div class="w-100">
    <div class="d-flex flex-wrap flex-gap-10 mb-4">
      <div class="flex-fill">
        <div class="card mb-0">
          <div class="card-body text-center p-2">
            <h5 class="my-1">{{ resume.total | currency }}</h5>
            <div class="bg-light rounded py-1 font-size-12 text-uppercase">Total</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="empty"></div>
    <div v-else>
      <Chart :chartdata="chartdata" :options="options"></Chart>
    </div>
  </div>
</template>